require("./src/assets/css/bootstrap.min.css");
require("./src/assets/css/hourly.css");
require("./src/assets/css/masonary.css");
